module.exports = __webpack_public_path__ + "static/media/iv_refer_earn_landing.c63caea3.svg";